module.exports = __webpack_public_path__ + "static/media/pen.45fb2793.svg";